


















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import _ from 'lodash'

// Components
import Swatches from 'vue-swatches'
import UserType from '@/components/shared/UserType.vue'
import EditModalLayout from '@/components/common/modals/EditModalLayout.vue'

@Component({
  components: { Swatches, UserType, EditModalLayout },
})
export default class CategoryEditModal extends Vue {
  @Prop()
  isOpen!: boolean

  @Prop()
  isNew!: boolean

  @Prop()
  data!: any

  formData: any = {}

  get categoryName(): string {
    const list: string[] = []
    if (!_.isEmpty(this.formData.category_1)) {
      list.push(this.formData.category_1)
    }
    if (!_.isEmpty(this.formData.category_2)) {
      list.push(this.formData.category_2)
    }
    if (!_.isEmpty(this.formData.category_3)) {
      list.push(this.formData.category_3)
    }

    const categoryName = list.join(' ')
    this.formData.name = categoryName

    return categoryName
  }

  @Watch('formData')
  updateData() {
    Object.keys(this.formData).forEach(k => {
      if (k.includes('category_')) {
        this.formData[k] = this.formData[k].trim()
      }
    })

    this.$emit('update:data', this.formData)
  }

  beforeUpdate() {
    this.formData = { ...this.data }
  }
}
